module.exports = __webpack_public_path__ + "img/eductorenviro_driving.44716da1.svg";